import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type FlyoutDrawerState = Readonly<{
    flyoutDrawerIsOpen: boolean;
}>;

const initialState: FlyoutDrawerState = {
    flyoutDrawerIsOpen: false,
};

const FlyoutDrawerData = createTypedReducerWithImmer(initialState, {
    "Custom/FlyoutDrawer/SetFlyoutDrawerIsOpen": (draft: Draft<FlyoutDrawerState>, action: { isOpen: boolean }) => {
        draft.flyoutDrawerIsOpen = action.isOpen;
    },
});

export default (reducers as any).xcentiumFlyoutDrawer = FlyoutDrawerData;

export type CustomFlyoutDrawerState = {
    xcentiumFlyoutDrawer: FlyoutDrawerState;
} & ApplicationState;

type Reducers = {
    flyoutDrawerReducer: typeof FlyoutDrawerData;
};

export type XCentiumFlyoutDrawerActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
